import { ListItemIcon, ListItemText, RouterListItemButton } from "@bvhi/ui-base";
import { useLocation, useMatches } from "@tanstack/react-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BVHIRoute } from "../config/navigation";
import { usePermissions } from "../hooks/use-permissions";

interface Props {
  route: BVHIRoute;
}

export const DrawerLinkButton = ({ route }: Props) => {
  const { t } = useTranslation(["routes"]);
  const { canNavigateTo } = usePermissions();
  const location = useLocation();

  const matches = useMatches();

  const isActive = useMemo(() => {
    if (matches.some((element) => element.routeId === route.id)) return true;
    return false;
  }, [matches, route.id]);

  const isDisabled = useMemo(() => {
    if (!route.permissions) return false;
    return !canNavigateTo(route);
  }, [route, canNavigateTo]);

  return (
    <RouterListItemButton
      disabled={isDisabled}
      selected={isActive !== false}
      sx={{ userSelect: "none" }}
      to={route.path}
      onClick={(event) => {
        if (location.pathname === route.path) {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      {route.icon && (
        <ListItemIcon>
          <route.icon />
        </ListItemIcon>
      )}
      {route.label && <ListItemText primary={t(route.label)} />}
    </RouterListItemButton>
  );
};
